<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    fill="none"
    aria-hidden="true"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
    stroke-width="1.5"
  >
    <path
      d="m13.827 7.386 2.968 3.065M18.692 5.343l-1.995 4.913M21.027 6.802c-.875 2.14-3.21 3.308-4.038 3.6-.146.049-.34 0-.389-.146-.34-.778-1.216-3.26-.34-5.4.875-2.14 3.21-3.308 4.038-3.6.146-.049.34 0 .389.146.34.778 1.216 3.26.34 5.4Z"
    />
    <path
      d="M16.6 10.256c-.243-.584-.778-2.14-.68-3.794-.098-.098-.147-.195-.244-.292-1.265-1.314-3.357-1.508-4.038-1.508-.146 0-.243.097-.243.243 0 .681.048 2.773 1.313 4.086 1.265 1.314 3.357 1.508 4.038 1.508a.369.369 0 0 0 .195-.097c-.146.049-.292 0-.34-.146ZM2.735 22.71v-8.27h2.433v-1.752l2.919-1.75v3.502h1.946v-1.752l2.919-1.75v3.502h2.432v-1.752l2.919-1.75v3.502h2.432v8.27h-18Z"
    />
    <path
      d="M12.951 16.873H10.52v1.946h2.432v-1.946ZM7.6 16.873H5.168v1.946H7.6v-1.946ZM18.303 16.873H15.87v1.946h2.433v-1.946Z"
    />
  </svg>
</template>
